import type { DeliveryChange } from './DeliveryChange';

export const config: DeliveryChange = {
    electronicDeliveryPayload: { mode: 'ONLY_ELECTRONIC' },
    postalDeliveryPayload: { mode: 'PAPER' },
    showElectronicDeliveryCard: true,
};
